import { Pipe, PipeTransform } from '@angular/core';
import type { SectionRowViewModel } from '../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';

@Pipe({
  name: 'getBadgesInlineWithName',
  standalone: false
})
export class GetBadgesInlineWithNamePipe implements PipeTransform {
  transform(rowVm: SectionRowViewModel): any {
    return rowVm?.getBadgesInlineWithName() || null;
  }
}
